import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import { numberFormatter } from '../../../../../utils/number';
import detractionBasicInformationPropTypes from '../proptypes/SalesTaxPropTypes';

const SalesTaxBasicInformationResource = ({
  taxRate,
  country: { name: countryName },
}) => (
  <>
      <ResourceProperty label="País:">{countryName}</ResourceProperty>
    <ResourceProperty label="Porcentaje de Impuesto:">
      {numberFormatter({
        value: taxRate,
        style: 'percent',
      })}
    </ResourceProperty>
  </>
);

SalesTaxBasicInformationResource.propTypes =
  detractionBasicInformationPropTypes;

export default SalesTaxBasicInformationResource;
